window.addEventListener("load", function () {
  setTimeout(function () {
    document.getElementById("loading-screen").style.display = "none";
    document.getElementById("page-content").style.display = "flex";
  }, 500);
});

document.addEventListener("DOMContentLoaded", () => {
  function updateStepOnScroll() {
    const steps = document.querySelectorAll(".scroll-step");
    let currentStep = null;

    steps.forEach((step) => {
      const rect = step.getBoundingClientRect();
      if (
        rect.top <= window.innerHeight / 2 &&
        rect.bottom > window.innerHeight / 2
      ) {
        currentStep = step.dataset.step;
      }
    });

    // Progress bar update
    const progressBar = document.getElementById("scroll-progress-bar");
    const totalSteps = steps.length;
    const activeIndex = [...steps].findIndex(
      (step) => step.dataset.step === currentStep
    );
    if (progressBar && activeIndex >= 0) {
      const scrollContainer = document.querySelector(".scroll");
      const currentStepEl = steps[activeIndex];
      if (scrollContainer && currentStepEl) {
        if (activeIndex === totalSteps - 1) {
          progressBar.style.height = `${scrollContainer.offsetHeight}px`;
        } else {
          const scrollTop = scrollContainer.offsetTop;
          const stepOffset = currentStepEl.offsetTop - scrollTop;
          const stepHeight = currentStepEl.offsetHeight;
          progressBar.style.height = `${stepOffset + stepHeight / 2}px`;
        }
      }
    }
  }

  // Reset on HTMX content swap (when switching arbeider/bediende)
  document.addEventListener("htmx:afterSwap", () => {
    const section = document
      .querySelector("[s-val\\:role].bg-red")
      ?.closest("section");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });

  window.addEventListener("scroll", updateStepOnScroll);
  updateStepOnScroll();
});
